"use client"

import { Phone, Mail, MapPin, Code, Briefcase, GraduationCap, Award, MessageCircle, Linkedin, FileText, BarChart3, Presentation, Languages } from 'lucide-react'
import "./CvPage.css"

export default function CV() {
  const skills = [
    { name: "JavaScript", level: 85 },
    { name: "React", level: 80 },
    { name: "Laravel", level: 90 },
    { name: "PHP", level: 85 },
    { name: "Node.js", level: 75 },
    { name: "HTML/CSS", level: 90 },
    { name: "MySQL", level: 80 },
  ]

  const officeSkills = [
    { name: "Microsoft Word", level: "Avancé", icon: FileText },
    { name: "Microsoft Excel", level: "Avancé", icon: BarChart3 },
    { name: "PowerPoint", level: "Intermédiaire", icon: Presentation },
    { name: "Google Docs", level: "Avancé", icon: FileText },
  ]

  const languages = [
    { name: "Arabe", level: "Langue maternelle" },
    { name: "Français", level: "Courant" },
    { name: "Anglais", level: "Intermédiaire" },
  ]

  const projects = [
    {
      title: "Gestion de Demande d'Engins - OCP",
      description: "Application de gestion des demandes d'engins pour l'Office Chérifien des Phosphates",
      tech: "Laravel, PHP, MySQL",
      type: "Stage Professionnel",
    },
    {
      title: "Etud Coloc",
      description: "Application web pour la colocation étudiante - Projet de fin d'études",
      tech: "Laravel, PHP, MySQL, JavaScript",
      type: "Projet de Fin d'Études",
    },
  ]

  return (
    <div>
      <div className="cv-container">
        {/* Header Section */}
        <div className="header-section">
          <div className="header-content">
            {/* Photo de profil placeholder */}
            <div className="profile-photo">
              <img src="/profile-photo.png" alt="Photo de profil de Khadija Khris" className="profile-photo-img" />
            </div>

            <div className="header-info">
              <h1 className="main-title">Khadija Khris</h1>
              <h2 className="job-title">Développeuse Web Full Stack</h2>
              <p className="description">
                Technicienne spécialisée en développement digital passionnée par la création d'applications web
                modernes. Expérience pratique avec Laravel, React et JavaScript.
              </p>
            </div>
          </div>
        </div>

        <div className="main-content">
          {/* Colonne de gauche */}
          <div className="sidebar">
            {/* Contact */}
            <div className="section-card">
              <h3 className="section-title">
                <Phone className="icon" />
                Contact
              </h3>
              <div className="contact-list">
                <div className="contact-item">
                  <Phone className="contact-icon" />
                  <a href="tel:0601618716" className="contact-link">
                    06 01 61 87 16
                  </a>
                </div>
                <div className="contact-item">
                  <Phone className="contact-icon" />
                  <a href="tel:0601546908" className="contact-link">
                    06 01 54 69 08
                  </a>
                </div>
                <div className="contact-item">
                  <MessageCircle className="contact-icon whatsapp" />
                  <a href="https://wa.me/212601618716" className="contact-link whatsapp">
                    WhatsApp
                  </a>
                </div>
                <div className="contact-item">
                  <Mail className="contact-icon" />
                  <a href="mailto:khadijakhris491@gmail.com" className="contact-link">
                    khadijakhris491@gmail.com
                  </a>
                </div>
                <div className="contact-item">
                  <Linkedin className="contact-icon" />
                  <a href="https://linkedin.com/in/khadija-khris-9857b8292" className="contact-link" target="_blank" rel="noopener noreferrer">
                    LinkedIn
                  </a>
                </div>
                <div className="contact-item">
                  <MapPin className="contact-icon" />
                  <span className="contact-link">El Jadida, Maroc</span>
                </div>
              </div>
            </div>

            {/* Compétences */}
            <div className="section-card">
              <h3 className="section-title">
                <Code className="icon" />
                Compétences Techniques
              </h3>
              <div className="skills-list">
                {skills.map((skill, index) => (
                  <div key={index} className="skill-item">
                    <div className="skill-header">
                      <span className="skill-name">{skill.name}</span>
                      <span className="skill-percentage">{skill.level}%</span>
                    </div>
                    <div className="progress-bar">
                      <div className="progress-fill" style={{ width: `${skill.level}%` }}></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Compétences Bureautiques */}
            <div className="section-card">
              <h3 className="section-title">
                <FileText className="icon" />
                Compétences Bureautiques
              </h3>
              <div className="office-skills">
                {officeSkills.map((skill, index) => {
                  const IconComponent = skill.icon
                  return (
                    <div key={index} className="office-skill-item">
                      <IconComponent className="office-skill-icon" />
                      <div className="office-skill-name">{skill.name}</div>
                      <div className="office-skill-level">{skill.level}</div>
                    </div>
                  )
                })}
              </div>
            </div>

            {/* Langues */}
            <div className="section-card">
              <h3 className="section-title">
                <Languages className="icon" />
                Langues
              </h3>
              <div className="languages-list">
                {languages.map((language, index) => (
                  <div key={index} className="language-item">
                    <div className="language-header">
                      <span className="language-name">{language.name}</span>
                      <span className="language-level">{language.level}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Colonne de droite */}
          <div className="content-area">
            {/* Formation */}
            <div>
              <h3 className="section-title-main">
                <GraduationCap className="icon-main" />
                Formation
              </h3>
              <div className="timeline">
                <div className="timeline-item">
                  <h4 className="timeline-title">Technicien Spécialisé en Développement Digital</h4>
                  <p className="timeline-company">ISTA Cité de l'Air</p>
                  <p className="timeline-date">2021 - 2023 • Formation de 2 ans</p>
                </div>
                <div className="timeline-item blue">
                  <h4 className="timeline-title">Formation JavaScript</h4>
                  <p className="timeline-company blue">Centre IET - El Jadida</p>
                  <p className="timeline-date">3 mois • Formation spécialisée</p>
                </div>
                <div className="timeline-item gray">
                  <h4 className="timeline-title">Baccalauréat</h4>
                  <p className="timeline-date">2023</p>
                </div>
              </div>
            </div>

            {/* Expérience */}
            <div>
              <h3 className="section-title-main">
                <Briefcase className="icon-main" />
                Expérience Professionnelle
              </h3>
              <div className="timeline-item green">
                <h4 className="timeline-title">Stagiaire Développeur</h4>
                <p className="timeline-company green">Office Chérifien des Phosphates (OCP)</p>
                <p className="timeline-date">6 semaines</p>
                <p className="timeline-description">
                  Développement d'une application de gestion de demande d'engins avec Laravel
                </p>
              </div>
              <div className="timeline-item blue">
                <h4 className="timeline-title">Agent Centre d'Appel</h4>
                <p className="timeline-company blue">Centre d'Appel</p>
                <p className="timeline-date">3 mois</p>
                <p className="timeline-description">
                  Gestion des appels clients, support technique et service clientèle. Développement des compétences en communication et résolution de problèmes.
                </p>
              </div>
            </div>

            {/* Projets */}
            <div>
              <h3 className="section-title-main">
                <Award className="icon-main" />
                Projets Réalisés
              </h3>
              <div className="projects-grid">
                {projects.map((project, index) => (
                  <div key={index} className="project-card">
                    <div className="project-header">
                      <h4 className="project-title">{project.title}</h4>
                      <span className="project-badge">{project.type}</span>
                    </div>
                    <p className="project-description">{project.description}</p>
                    <p className="project-tech">Technologies: {project.tech}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer">
          <p className="footer-text">
            Disponible pour de nouvelles opportunités •
            <a href="tel:0601618716" className="footer-link">
              06 01 61 87 16
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
